module.exports = __webpack_public_path__ + "img/gold_saving.63e2d39e.png";